import { ElementType, IElement } from '../../../../models/Element';
import { ElementHeaderType } from '../../../utils';

export type HomeLeftDescriptionWithFloatingWindowElement = IElement & {
  heading: string;
  heading_type?: ElementHeaderType;
  description: string;
  floating_text: string;
  button_title: string;
  button_url: string;
  button_url_is_external: boolean;
  image_preview: string;
  image_preview_alt: string;
};

export const defaultHomeLeftDescriptionWithFloatingWindowElement: HomeLeftDescriptionWithFloatingWindowElement =
  {
    id: 0,
    name: ElementType.HOME_IMAGE_LEFT_DESCRIPTION_WITH_FLOATING,
    heading: 'De vrijheid om te doen wat jij wil.',
    description:
      'Productprijzen worden automatisch berekend op basis van de gewenste huurperiode daarnaast kunnen producten online verlengd worden.',
    floating_text: 'Bij Verbonden regel je zelf jouw telefonie zaken, 24/7.',
    button_title: 'Lees meer',
    button_url: '',
    button_url_is_external: false,
    image_preview: '',
    image_preview_alt: '',
  };
